import {
  TooltipProvider,
  TooltipTrigger,
  TooltipContent,
  Tooltip,
} from "@/shadcnComponents/ui/tooltip";
import mixpanel from "mixpanel-browser";
import { Button } from "@/shadcnComponents/ui/button";
import { FiPhoneCall } from "react-icons/fi";
import { MdMailOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const BrandCollabSidebar = ({
  children,
  navigateTo,
}: {
  children?: React.ReactNode;
  navigateTo?: string;
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className="flex flex-col w-[260px] min-w-[260px] fixed top-0  items-center  p-5 box-border gap-5 font-inter h-full z-10 bg-[#171717] border-r-[1px] border-[#262626]"
        style={{ boxShadow: "4px 0px 8px 0px rgba(33, 33, 33, 0.08)" }}
      >
        <div className="w-full">
          {navigateTo && (
            <Button
              className="text-[color:var(--Natural-500,#9E9E9E)] gap-3 text-sm px-0 not-italic font-medium leading-[24px]"
              onClick={() => {
                mixpanel.track(
                  `Influencer Brand Collab Details Sidebar : Back to dashboard - Clicked `
                );
                navigate(navigateTo);
              }}
              variant="link"
            >
              <ArrowLeft size={20} />
              <span>Back to Dashboard</span>
            </Button>
          )}
        </div>

        <section
          style={{ scrollbarWidth: "none" }}
          className="flex-1 w-full overflow-x-scroll"
        >
          {children}
        </section>

        <section>
          <div className="flex flex-col items-center gap-2 border rounded-[5px] border-solid border-[#DC2627] p-2">
            <div className="flex  items-center gap-2">
              <img
                src={
                  "https://anchors-assets.s3.ap-south-1.amazonaws.com/aesha_anchors.png"
                }
                alt="logo"
                className="w-10 h-10 rounded-full"
              />

              <section className="flex flex-col gap-1">
                <span className="flex gap-1 items-center text-[16px] mt-[-10px] font-bold text-[color:var(--Shade-White,#FFF)]">
                  {"Need help?"}
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Button
                          onClick={() => {
                            mixpanel.track(
                              "Campaign Sidebar: Need Help Phone - clicked"
                            );
                            window.open("tel:+918799710137");
                          }}
                          className="p-0"
                          variant="ghost"
                        >
                          <FiPhoneCall size={18} />
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p>+918799710137</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>

                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Button
                          onClick={() => {
                            mixpanel.track(
                              "Campaign Sidebar: Need Help Email - clicked"
                            );
                            window.open("mailto:collab@anchors.in");
                          }}
                          className="p-0"
                          variant="ghost"
                        >
                          <MdMailOutline size={18} />
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p>collab@anchors.in</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </span>
                <p className="text-[color:var(--Shade-White,#FFF)] text-xs not-italic mt-[-10px] font-medium leading-[normal]">
                  {"I'm Aesha, here for you!"}
                </p>
              </section>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
